<ol class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs; let i = index">
    <span [ngClass]="{link: breadcrumb.route}" [routerLink]="breadcrumb.route">
      {{ breadcrumb.title }}
    </span>
    <i *ngIf="i < breadcrumbs.length - 1" class="fas fa-angle-right"></i>
  </li>
</ol>
